var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsDarkRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9C5987E3-E98F-411C-A368-046ADFE6D9A0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Dark-/-remove"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Icon-Path",
    fill: "#32325D",
    points: "11.3333333 10.3933333 10.3933333 11.3333333 8 8.94 5.60666667 11.3333333 4.66666667 10.3933333 7.06 8 4.66666667 5.60666667 5.60666667 4.66666667 8 7.06 10.3933333 4.66666667 11.3333333 5.60666667 8.94 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,2 C4.682,2 2,4.682 2,8 C2,11.318 4.682,14 8,14 C11.318,14 14,11.318 14,8 C14,4.682 11.318,2 8,2 Z",
    id: "Icon-Shape",
    stroke: "#32325D",
    strokeWidth: 1.13333333,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsDarkRemove);
export default __webpack_public_path__ + "static/media/icons-dark-remove.1ff56fcc638faed803dab4c7058d86e6.svg";
export { ForwardRef as ReactComponent };